import type { ReactNode } from 'react'
import { ComponentsNavigation } from './navigation'

interface ComponentsLayoutProps {
  children: ReactNode
  title: string
  description?: string
}

export const ComponentsLayout = ({ children, title, description }: ComponentsLayoutProps) => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-6xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Biblioteca de Componentes
          </h1>
          <p className="text-lg text-gray-600">
            Visualize e teste todos os componentes disponíveis no sistema
          </p>
        </div>

        {/* Navegação */}
        <ComponentsNavigation />

        {/* Header da seção */}
        <div className="text-center mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-2">
            {title}
          </h2>
          {description && (
            <p className="text-gray-600">
              {description}
            </p>
          )}
        </div>

        {/* Conteúdo */}
        {children}
      </div>
    </div>
  )
}
